<template>
  <div class="awards-terms-and-conditions-heading" v-if="isActiveSection">
    <p class="awards-terms-and-conditions-text" v-html="award.terms_and_conditions" />
  </div>
  <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      award: 'awards/award',
    }),
    isActiveSection() {
      return this.award && this.award.available_sections ? this.award.available_sections.includes('terms_and_conditions') : false;
    },
  },
};
</script>

<style scoped>
.awards-terms-and-conditions-heading {
  background-color: #ffffff;
  padding: 17px 4px 3px 3px;
  width: 100%;
  margin:auto;
}
.awards-terms-and-conditions-text {
  text-align: center;
  padding: 4px 15px 1px 15px;
}
</style>
<style>
.awards-terms-and-conditions-text img {
  max-width: 565px;
  max-height: 300px;
  object-fit: cover;
}
.awards-terms-and-conditions-text iframe {
  width: 565px;
  height: 300px;
  object-fit: cover;
}
</style>
